import { getTeamBadgeStyle, getTeamFactionName } from './teamTheme';

interface TeamBadgeProps {
  teamColor: string;
  size?: 'sm' | 'md' | 'lg';
}

const SIZE_CLASSES = {
  sm: 'px-3 py-1 text-sm',
  md: 'px-4 py-1.5 text-base',
  lg: 'px-5 py-2 text-lg',
};

function TeamBadge({ teamColor, size = 'md' }: TeamBadgeProps) {
  const badgeStyle = getTeamBadgeStyle(teamColor);
  const factionName = getTeamFactionName(teamColor);
  const sizeClass = SIZE_CLASSES[size];

  return (
    <span className={`inline-block rounded-full border-2 font-heading font-bold tracking-wider ${badgeStyle} ${sizeClass}`}>
      {factionName}
    </span>
  );
}

export default TeamBadge;
